import React from 'react';
import TemplateCollections from '../../components/crm/TemplateCollections';

// Finance starts with one empty section; staff add their own from the page.
const DEFAULT_FINANCE_SECTIONS = [{ id: 'general', label: 'General', items: [] }];

const FINANCE_CONFIG = {
  title: 'Finance Materials',
  pillar: 'Finance',
  structureId: 'finance',
  defaultSections: DEFAULT_FINANCE_SECTIONS,
  backTo: '/crm/templates',
  accent: {
    tabActive: 'bg-green-600',
    spinner: 'border-green-600',
    button: 'bg-green-600 hover:bg-green-700',
  },
  sectionPlaceholder: 'e.g. Budgeting',
  itemPlaceholder: 'e.g. Cash Flow Worksheet',
  showCanvaLink: true,
};

const FinanceCollections = () => <TemplateCollections config={FINANCE_CONFIG} />;

export default FinanceCollections;
